<script setup>
import { useRoute } from 'vue-router'
import ToastContainer from './components/ToastContainer.vue'
import { useCustomToast } from './composables/useCustomToast'

const route = useRoute()
const { setToastContainer } = useCustomToast()
</script>

<template>
  <router-view></router-view>
  <ToastContainer ref="toastContainer" position="bottom-left" />
</template>
